// extracted by mini-css-extract-plugin
export default {"messagesList":"Chat_messagesList__rJ+Zx","messagesRow":"Chat_messagesRow__fgVgy"};